import { createContext, useContext, useState } from 'react';
import LoadingBackdrop from '../Components/LoadingBackdrop/LoadingBackdrop';
import Dialog from './Dialog';


const DialogContext = createContext(null);

export const DialogManager = ({ children }) => {
    const [dialog, setDialog] = useState(null);
    const [loading, setLoading] = useState(false);

    return (
        <DialogContext.Provider value={{ dialog, setDialog, loading, setLoading }}>
            <Dialog dialog={dialog} setDialog={setDialog} />
            <LoadingBackdrop open={loading} />
            {children}
        </DialogContext.Provider>
    );
};

export const useDialog = () => useContext(DialogContext);
